<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>角色管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/role/add']">添加角色</el-button>
		</div>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column width="100" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column prop="description" label="描述"></el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['supplier/role/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-if="scope.row.status != 2" v-auth="['supplier/role/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/supplier/role/index', {
					page: this.page,
					limit: this.pageSize
				})
				.then(res => {
					this.isLoad = false
					// 获取数据
					this.list = res.data.list.data
					// 页数 page
					this.total = res.data.list.total
				})
				.catch(() => {
					this.isLoad = false
				})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Settings/roleEdit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Settings/roleEdit.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.page = val
				this.loadList()
			},
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/supplier/role/delete', {
					data: {
						id: id
					}
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
		}
	}
</script>
<style scoped>
</style>
